import {z} from '@hono/zod-openapi';

import {InventoryTurnoverMonthSchema} from './InventoryTurnoverMonthSchema';

export const InventoryTurnoverResponseSchema = z
  .object({
    asOf: z.string().date(),
    capturedAt: z.string(),
    timezone: z.string(),
    months: z.array(InventoryTurnoverMonthSchema),
  })
  .openapi('InventoryTurnoverResponse');

export type InventoryTurnoverResponse = z.infer<typeof InventoryTurnoverResponseSchema>;
